import { useCommonComponentContext } from "@maysoft/common-component-react";
import { CssBaseline, StyledEngineProvider } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import { DefaultTheme as Theme } from "@mui/system";
import { createContext, useContext, useEffect } from "react";
import { setLocale } from "yup";

import theme from "../assets/theme";
import Global from "../commons/global";
import Strings from "../constants/strings";

import { IMenuItem } from "../commons/interfaces";
import { MaterialUIControllerProvider } from "../components/context";
import { IRecordChannel } from "../containers/channel/useChannel";

import "../styles/main.css";
import "../styles/muiIcon.css";

interface ICommunityCommonContextType {
    channelId?: string;
    communityId?: string;
    communityCode?: string;
    communityName?: string;
    listChannels?: IRecordChannel[];
    onGoBack?: () => void;
    onCallBack?: () => void;

    routes: IMenuItem[];
    pathNameCurrent?: string;
    onNavigate: (pathName?: string, target?: any) => void;

    searchText?: string | undefined | null;
    onSearch?: (value: string | undefined | null) => void;
}

export const CommunityCommonContext = createContext<ICommunityCommonContextType>(null!);

export const useCommunityCommonContext = () => useContext(CommunityCommonContext);

export const CommunityCommonProvider = (props: {
    children: React.ReactNode;
    value: ICommunityCommonContextType;
    theme?: Partial<Theme> | ((outerTheme: Theme) => Theme);
}) => {
    const { axios, language } = useCommonComponentContext();
    Global.axios = axios as any;

    useEffect(() => {
        setLocale({
            mixed: {
                required: Strings.Validation.REQUIRED,
            },
            string: {
                email: Strings.Validation.EMAIL_ADDRESS,
            },
        });
    }, [language]);

    return (
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={props.theme || theme}>
                <MaterialUIControllerProvider>
                    <CommunityCommonContext.Provider value={props.value}>
                        <CssBaseline />
                        {props.children}
                    </CommunityCommonContext.Provider>
                </MaterialUIControllerProvider>
            </ThemeProvider>
        </StyledEngineProvider>
    );
};
